
import { BirdieGameGroup, Course } from "@/types";
import { Badge } from "@/components/ui/badge";
import { useLocation } from "react-router-dom";

interface HeaderProps {
  title: string;
  course?: Course;
  group?: BirdieGameGroup;
  hideGroupDetails?: boolean;
  children?: React.ReactNode; // Add this line to allow for children
}

const Header = ({ title, course, group, hideGroupDetails = false, children }: HeaderProps) => {
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  return (
    <div className="pt-4 pb-4 px-4 flex flex-col">
      {!isHomePage && (
        <div className="flex justify-between items-center">
          <h1 className="font-display text-2xl font-semibold text-forest">
            {title}
          </h1>
          {children && <div>{children}</div>}
        </div>
      )}
      {course && (
        <p className="text-sm text-muted-foreground mt-1">
          {course.name}, {course.location}
        </p>
      )}
      {group && !hideGroupDetails && (
        <div className="flex items-center mt-1">
          <span className="text-sm text-muted-foreground">
            {group.name} - {group.year}
          </span>
          {group.bet && (
            <span className="ml-2 text-xs bg-accent px-2 py-0.5 rounded-full">
              Bet: {group.bet}
            </span>
          )}
        </div>
      )}
      {group && hideGroupDetails && group.bet && (
        <div className="mt-1">
          <Badge variant="outline" className="bg-gold/15 text-forest border-none">
            Bet: {group.bet}
          </Badge>
        </div>
      )}
    </div>
  );
};

export default Header;
